const isValidURL = (str) => {
    // Regular expression for a simple URL pattern
    var urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
    return urlRegex.test(str);
}

export {isValidURL}